const HaulingContractType = {
    // Producer hauling contracts may not already have the HaulingContractType.ProducerHaulerContract
    ProducerHaulerContract: 'producer_hauler_contract',
    HaulerProcessorRouteContract: 'hauler_processor_route_contract',
};

export default HaulingContractType;
